var editDriverUserTemplate = require('html/templates/editDriverUser')();
var t = require('js/lib/translate').t;

driverUsersCtrl.$inject = ['$scope', '$rootScope', '$controller', '$routeParams', '$filter', '$window', '$document', '$timeout', 'modal', 'load'];

function driverUsersCtrl($scope, $rootScope, $controller, $routeParams, $filter, $window, $document, $timeout, modal, load) {

  $controller('planCtrl', { $scope: $scope });

  $scope.search = {
    text: undefined
  };

  $scope.formatPhone = require('js/lib/util').formatPhone;
  var latinize = require('js/lib/util').latinize;

  $scope.filter = {
    active: true
  };

  $scope.languages = [
    { id: 'no', name: 'Norsk' },
    { id: 'sv', name: 'Svenska' },
    { id: 'fi', name: 'Suomalainen' },
    { id: 'en', name: 'English' },
    { id: 'fr', name: 'Français' }
  ];

  $scope.setStatus = function($event, active) {
    $scope.filter.active = active;
    $event.preventDefault();
  };

  $scope.countStatus = function(active) {
    var users = $rootScope.driverUsers;

    return $filter('filter')(users, {
      active: active
    }).length;
  };

  $scope.openEditUser = function(user) {

    if (user) {
      $scope.user = user.editClone();
    } else {
      $scope.user = {
        userName: "",
        regeneratePassword: true,
        isNewUser: true
      };
    }

    modal.open({
      scope: $scope,
      klass: 'edit-user',
      title: t(user ? 'driverUsersHeaderEdit' : 'driverUsersHeaderNew'),
      body: editDriverUserTemplate,
      onClose: function() {
        resetEdit(false);
      }
    });

  };

  var resetEdit = function(closeModalAndReload) {
    // Reset errors
    $scope.userNameUsed = false;
    $scope.userNameIllegalCharacters = false;
    $scope.userNameTooShort = false;
    $scope.invalidPhone = false;
    $scope.languageRequired = false;

    if (closeModalAndReload) {
      $scope.closeModal();
      $window.location.reload(true);
    }
    $scope.isSaving = false;

  };

  $scope.deactivateDriverUser = function(user) {
    $scope.saveDriverUser(user, false);
  };
  $scope.activateDriverUser = function(user) {
    $scope.saveDriverUser(user, true);
  };
  $scope.closeDriverUserModal = function() {
    resetEdit(true);
  };

  $scope.suggestUsername = function(user) {
    if (user.userName == undefined || user.userName.length == 0) {
      // Suggestion: 2 from first + 4 from last
      var firstPart = (user.firstName ? user.firstName.substring(0, Math.min(2, user.firstName.length)).toLowerCase() : "");
      var lastPart = (user.lastName ? user.lastName.substring(0, Math.min(4, user.lastName.length)).toLowerCase() : "");
      user.userName = firstPart + lastPart;
      // Replace invalid chars
      user.userName = latinize(user.userName);
      user.userName = user.userName.replace(/-/g, "")
    }
  };

  $scope.saveDriverUser = function(user, newActiveState) {
    $scope.isSaving = true;
    for (var prop in user) {
      user[prop] = user[prop] || null;
    }

    var generatePasswordForExistingUser = !user.isNewUser && user.regeneratePassword;

    if (user.isNewUser) {
      resetEdit(false);
      if (user.userName.length < 5) {
        $scope.userNameTooShort = true;
        return;
      }
    }

    if (newActiveState !== undefined)
      user.active = newActiveState;

    load.saveDriverUser(user).then(function(data) {

      if (generatePasswordForExistingUser) {
        load.generateAndSendPasswordForDriverUser(user.userName).then(function(data) {
          // Existing user - Password regenerated
          $scope.user.password = data.password;
          $scope.user.regeneratePassword = false;
          resetEdit(false);

        }).catch(function(error) {
          console.log("generateAndSendPasswordForDriverUser ERROR", error);
        });
      } else if (user.isNewUser) {
        // New user - password was generated
        $scope.user.password = data.password;
        resetEdit(false);
      } else {
        // Existing user - no new password
        resetEdit(true);
      }

    }).catch(function(error) {
      if (error.ignoredStatus === 400) {  // 400 Bad request
        if (error.data && error.data.errorKey) {
          if (error.data.errorKey === 'username.is.already.in.use') {
            $scope.userNameUsed = true;
          } else if (error.data.errorKey === 'illegal.username') {
            $scope.userNameIllegalCharacters = true;
          } else if (error.data.errorKey === 'phone.not.valid') {
            $scope.invalidPhone = true;
          } else if (error.data.errorKey === 'language.required') {
            $scope.languageRequired = true;
          }
        }
        if (newActiveState !== undefined)
          $scope.user.active = !$scope.user.active;

        console.log("saveDriverUser", error);
        $scope.isSaving = false;
      }
    });
  };

}

module.exports = driverUsersCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/controllers/driverUsersCtrl.js
 ** module id = 127
 ** module chunks = 1
 **/